import React from "react";
import { LegalPage } from "@/components/LegalPage";

export default function DeleteData() {
  return <LegalPage docKey="deleteData" testId="legal-delete-data-screen" />;
}
